import React, { useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import { PurchaseSuccessContent } from '../components/PurchaseSuccessContent'
import { PurchaseErrorMessage } from '../components/PurchaseErrorMessage'

const RETURN_TO_APP_URL = 'mangabang://external_payment/coin_purchase_finish'
const COIN_PURCHASE_URL = '/external_payment/coin_purchase'

export const PurchaseComplete = ({ purchaseData }) => {
  const location = useLocation()
  const state = location.state

  // データ取得の優先順位:
  // 1. location.state（ReactRouter経由の場合）
  // 2. props（Rails経由の直接アクセスの場合）
  const purchasedCoinCount = state?.purchasedCoinCount ?? purchaseData?.purchasedCoinCount
  const totalCoinCount = state?.totalCoinCount ?? purchaseData?.totalCoinCount
  const price = state?.price ?? purchaseData?.price

  // 3秒後に自動でアプリに戻る（成功時のみ）
  useEffect(() => {
    if (!state?.error && !state?.cancel) {
      const timer = setTimeout(() => {
        window.location.href = RETURN_TO_APP_URL
      }, 3000)
      return () => clearTimeout(timer)
    }
  }, [state])

  // コイン購入画面に戻る
  const handleBackToCoinPurchase = () => {
    window.location.href = COIN_PURCHASE_URL
  }

  // stateもpropsもない場合はエラー表示（想定外のケース）
  if (!state && !purchaseData) {
    return <PurchaseErrorMessage onReturnClick={handleBackToCoinPurchase} onLogoClick={handleBackToCoinPurchase} />
  }

  // アプリに戻るボタンのクリック処理
  const handleReturnToApp = () => {
    window.location.href = RETURN_TO_APP_URL
  }

  return (
    <PurchaseSuccessContent
      purchasedCoinCount={purchasedCoinCount}
      price={price}
      totalCoinCount={totalCoinCount}
      onReturnClick={handleReturnToApp}
      onLogoClick={handleBackToCoinPurchase}
    />
  )
}
